import Filters from "components/common/Filters";
import CommonTitleBar from "components/common/CommonTitleBar";
import NoDataFound from "components/common/NoDataFound";
import Spinners from "components/common/Spinners";
// import {
//   formatDate,
//   formatDateTime,
//   formatPlanType,
//   getMinMaxDate,
//   getRelativeTimeFromNow,
//   setPageTitle,
// } from "components/common/utils";

import { subscriptionsStatus } from "components/constants/StatusKeys";
import React, { useEffect, useState } from "react";
import { Col, Container, Dropdown, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  resetFilters,
  setDates,
  setKeyword,
  setSortConfig,
  setSortedSubscriptions,
} from "store/reducers/subscriptionsReducer";
// import arrowFilter from "assets/icons/arrowFilter.svg";
import { Ellipsis } from "lucide-react";
import Paginations from "components/common/Paginations";
import TableShimmer from "components/ShimmerEffects/CommonShimmer/TableShimmer";
import { orderByOptions, statusOptions } from "components/constants/StatusKeys";

import {
  formatDate,
  formatFilterOptions,
  formatPlanType,
  getMinMaxDate,
  getRelativeTimeFromNow,
} from "components/common/Utils";
import { getSubscriptions } from "store/actions/subscriptionsSlice";
import { getOrganistionList } from "store/actions/organizationSlice";

const Subscriptions = () => {
  const { t } = useTranslation();

  document.title = t("Subscriptions | Work space");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    loading,
    isLoading,
    subscriptions,
    perPage,
    totalCount,
    totalPages,
    currentPage,
    filters,
  } = useSelector((state) => state.Subscriptions);

  const [selectedFilters, setSelectedFilters] = useState(
    filters || {
      status: -1,
      orderBy: -1,
      keyword: "",
      dates: [],
      organizationId: "",
      sortField: "",
      sortDirection: "asc",
    }
  );

  const { organisationsList } = useSelector((state) => state.Organizations);
  const [showDropdown, setShowDropdown] = useState(false);

  // const [keyword, setKeyword] = useState("");
  // const [dates, setDates] = useState([]);
  // const [sortField, setSortField] = useState("");
  // const [sortDirection, setSortDirection] = useState("asc");

  useEffect(() => {
    getAllData();
  }, []);
  useEffect(() => {
    dispatch(getOrganistionList());
  }, [dispatch]);

  const getAllData = (page, action) => {
    const { actionType } = action || {}; // SEARCH, RESET, RESET_KEYWORD
    const isReset = actionType === "RESET";
    const { organizationId, status, orderBy ,keyword ,dates ,sortDirection } = selectedFilters;

    const payload = {
      perPage,
      pageNo: page || 1,
      status: isReset ? -1 : status,
      orderBy: isReset ? -1 : orderBy,
      organizationId: isReset ? "" : organizationId,
      keyword: ["RESET", "RESET_KEYWORD"].includes(actionType)
        ? ""
        : keyword || "",
      dateRange: isReset ? {} : getMinMaxDate(dates),
    };

    dispatch(getSubscriptions(payload));
  };

  const handleReset = () => {
    setSelectedFilters(filters);
    dispatch(resetFilters());
    getAllData(1, { actionType: "RESET" });
  };

  const handleSort = (field) => {
    // Only sort specific fields
    const sortableFields = [
      "date",
      "users",
      "startDate",
      "endDate",
      "coupon",
      "total",
    ];
    if (!sortableFields.includes(field)) return;

    // Toggle direction if clicking the same field
    const newDirection = filters?.sortField === field && filters?.sortDirection === "asc" ? "desc" : "asc";

    dispatch(setSortConfig({ field, direction: newDirection }));

    // Create a sorted copy of the subscriptions array
    const sortedData = [...subscriptions].sort((a, b) => {
      // Handle numeric fields
      if (field === "users" || field === "total") {
        const valueA = Number(a[field]) || 0;
        const valueB = Number(b[field]) || 0;
        return newDirection === "asc" ? valueA - valueB : valueB - valueA;
      }

      // Handle date fields
      if (field === "date" || field === "startDate" || field === "endDate") {
        if (!a[field]) return 1;
        if (!b[field]) return -1;

        const dateA = new Date(a[field]).getTime();
        const dateB = new Date(b[field]).getTime();
        return newDirection === "asc" ? dateA - dateB : dateB - dateA;
      }

      // Handle string fields (coupon)
      if (field === "coupon") {
        if (!a[field]) return 1;
        if (!b[field]) return -1;

        return newDirection === "asc"
          ? a[field].localeCompare(b[field])
          : b[field].localeCompare(a[field]);
      }

      return 0;
    });

    dispatch(setSortedSubscriptions(sortedData));
  };

  const SortableHeader = ({ field, label }) => (
    <div className="c_p" onClick={() => handleSort(field)}>
      {/* <img src={arrowFilter} width={16} height={16} alt="arrow" /> */}
      {t(label)}
    </div>
  );
  const searchfilters = [
    {
      key: "status",
      placeholder: "Status",
      options: statusOptions,
      type: "singleSelect",
    },
    {
      key: "orderBy",
      placeholder: "Order By",
      options: orderByOptions,
      type: "singleSelect",
    },
    {
      key: "organizationId",
      placeholder: "Organisation",
      options: formatFilterOptions(organisationsList),
      type: "singleSelect",
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content common_page">
        <Container fluid>
          <CommonTitleBar title={t("Subscriptions")} />
          <div className="common_wrapper">
            <Filters
              keyword={filters?.keyword}
              setKeyword={(value) => dispatch(setKeyword(value))}
              onSearch={getAllData}
              onReset={handleReset}
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              dates={filters?.dates}
              filters={searchfilters}
              setDates={(value) => dispatch(setDates(value))}
            />
            <Row>
              <Col lg={12}>
                {loading ? (
                  <TableShimmer col={11} />
                ) : subscriptions.length === 0 ? (
                  <NoDataFound text={t("No Subscription found")} />
                ) : (
                  <div
                    className="common_table_style mt_20"
                    style={{ minHeight: showDropdown ? 190 : "unset" }}
                  >
                    <Table>
                      <thead className="t_head">
                        <tr>
                          <th>
                            <SortableHeader field="date" label="Date" />
                          </th>
                          <th>Status</th>
                          <th>Subscription ID</th>
                          <th>
                            <SortableHeader
                              field="startDate"
                              label="Start Date"
                            />
                          </th>
                          <th>
                            <SortableHeader field="users" label="End Date" />
                          </th>
                          {/* <th>
                            <SortableHeader field="endDate" label="End Date" />
                          </th> */}
                          {/* <th>
                            <SortableHeader field="coupon" label="Coupon" />
                          </th> */}
                          {/* <th>
                            <SortableHeader field="total" label="Total" />
                          </th> */}
                          {/* <th>Actions </th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {subscriptions?.map((item, index) => (
                          <tr key={item._id}>
                            <td>
                              <p className="w_fit_content">
                                {getRelativeTimeFromNow(item?.createdAt)}
                              </p>
                            </td>
                            <td>
                              {
                                <p
                                  className={`subscriptions_status ${
                                    subscriptionsStatus?.find(
                                      (option) => option.value === item?.status
                                    )?.className
                                  }`}
                                >
                                  {
                                    subscriptionsStatus?.find(
                                      (option) => option.value === item?.status
                                    )?.name
                                  }
                                </p>
                              }
                            </td>
                            <td>
                              <div
                                onClick={() =>
                                  navigate(
                                    `/management/subscriptions/subscription-details?id=${item?._id}`
                                  )
                                }
                                className="text-decoration-underline c_p"
                              >
                                {item?.subscriptionNumber}
                              </div>
                            </td>
                            <td>
                              {formatDate(
                                item?.billingCycleStart,
                                "dd MMM, yyyy"
                              )}
                            </td>
                            <td>
                              {formatDate(
                                item?.billingCycleEnd,
                                "dd MMM, yyyy"
                              )}
                            </td>
                            {/* <td>
                              <p className="w_fit_content">
                                {item?.total} {item?.currency}
                              </p>
                            </td> */}
                            {/* <td>
                              <Dropdown
                                className="custom_dropdown list_action_dropdown table_action_btn"
                                drop="down"
                                onToggle={(isOpen) => setShowDropdown(isOpen)}
                              >
                                <Dropdown.Toggle>
                                  <Ellipsis className="text_black" />
                                </Dropdown.Toggle>

                                <Dropdown.Menu align="end">
                                  <Dropdown.Item
                                    href="#"
                                    onClick={() =>
                                      navigate(
                                        `/customers/customer-information?id=${item?.userId}`
                                      )
                                    }
                                  >
                                    {t("View Customer")}
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    href="#"
                                    onClick={() =>
                                      navigate(
                                        `/management/subscriptions/subscription-details?id=${item?._id}`
                                      )
                                    }
                                  >
                                    {t("View Subscription")}
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td> */}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </Col>
            </Row>
          </div>
          {!loading && (
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={(page) => {
                getAllData(page);
              }}
              totalCount={totalCount}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Subscriptions;
